import React, { useState } from 'react'

const CopyButton = ({
    text,
    divClassName = '',
    iconClassName = '',
    color = 'color-gray',
    onCopyCallback = null,
    onTimeOutCallback = null
}) => {

    const [copied, setCopied] = useState(null)


    const handleClickCopyButton = (text) => {
        setCopied(true);
        if (onCopyCallback) 
            onCopyCallback();
        navigator.clipboard.writeText(text);
        setTimeout(() => {
            setCopied(false);
            if (onTimeOutCallback)
                onTimeOutCallback();
        }, 1500);
    }

    return (
        <React.Fragment>
            <div className={divClassName} style={divClassName ? {} : {display: 'contents'}}>
                <i className={`fas fa-fw ${copied ? 'fa-check-circle' : 'fa-copy'} cursor-pointer ${color} ${iconClassName}`} onClick={() => handleClickCopyButton(text)} />
            </div>
        </React.Fragment>
    )
}

export default CopyButton